const services = [
  {
    icon: 'ri-home-2-line',
    title: 'Roof Replacement',
    desc: 'Full-scale replacements for residential and commercial properties with premium materials and minimal disruption.',
    tag: 'Most Popular',
    img: 'https://public.readdy.ai/ai/img_res/8a66880f46903309e8ca9140bed6c553.jpg',
  },
  {
    icon: 'ri-tools-line',
    title: 'Roof Repair',
    desc: 'Targeted repairs addressing leaks, storm damage, and structural issues to extend the life of your roof.',
    tag: 'Fast Response',
    img: 'https://readdy.ai/api/search-image?query=skilled%20professional%20roofer%20expertly%20repairing%20premium%20asphalt%20shingles%20on%20upscale%20residential%20home%2C%20bright%20sunny%20day%2C%20crisp%20blue%20sky%2C%20safety%20harness%2C%20precise%20craftsmanship%20close-up%2C%20high-end%20suburban%20neighborhood%2C%20sharp%20professional%20photography&width=800&height=560&seq=svc_premium_02&orientation=landscape',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Roof Installation',
    desc: 'Professional installation using high-performance roofing systems engineered for durability and weather resistance.',
    tag: 'Commercial & Residential',
    img: 'https://readdy.ai/api/search-image?query=professional%20roofing%20installation%20team%20working%20on%20large%20modern%20commercial%20building%2C%20new%20flat%20membrane%20roof%20being%20installed%2C%20bright%20clear%20sky%2C%20industrial%20roofing%20project%2C%20aerial%20perspective%2C%20sharp%20professional%20photography%2C%20clean%20organized%20worksite&width=800&height=560&seq=svc_premium_03&orientation=landscape',
  },
  {
    icon: 'ri-thunderstorms-line',
    title: 'Storm Damage Restoration',
    desc: 'Insurance-supported restoration for wind, hail, and hurricane damage — we handle the claims process with you.',
    tag: 'Insurance Supported',
    img: 'https://readdy.ai/api/search-image?query=dramatic%20before%20and%20after%20storm%20damage%20roof%20restoration%20on%20luxury%20suburban%20home%2C%20clearing%20storm%20sky%20with%20golden%20sunlight%20breaking%20through%20clouds%2C%20professional%20restoration%20crew%2C%20Texas%20neighborhood%2C%20cinematic%20photography%2C%20high%20contrast%20dramatic%20lighting&width=800&height=560&seq=svc_premium_04&orientation=landscape',
  },
  {
    icon: 'ri-layout-right-line',
    title: 'Siding',
    desc: 'Premium siding installation and replacement to protect and dramatically enhance your property\'s curb appeal.',
    tag: 'Exterior Solutions',
    img: 'https://readdy.ai/api/search-image?query=stunning%20luxury%20home%20exterior%20with%20brand%20new%20premium%20fiber%20cement%20siding%20installation%2C%20elegant%20gray%20and%20white%20color%20scheme%2C%20crisp%20clean%20lines%2C%20beautiful%20landscaping%2C%20bright%20sunny%20day%2C%20high-end%20real%20estate%20photography%2C%20sharp%20professional%20image&width=800&height=560&seq=svc_premium_05&orientation=landscape',
  },
  {
    icon: 'ri-water-flash-line',
    title: 'Gutters',
    desc: 'Complete gutter installation and replacement to protect your foundation and landscaping from water damage.',
    tag: 'Full Exterior',
    img: 'https://readdy.ai/api/search-image?query=premium%20seamless%20copper%20and%20aluminum%20gutter%20system%20installed%20on%20elegant%20luxury%20home%2C%20close-up%20detail%20of%20perfect%20craftsmanship%2C%20clean%20architectural%20lines%2C%20lush%20green%20landscaping%2C%20bright%20daylight%2C%20high-end%20real%20estate%20photography&width=800&height=560&seq=svc_premium_06&orientation=landscape',
  },
];

export default function Services() {
  return (
    <section id="services" className="py-28 bg-[#f7f6f4]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-20">
          <div>
            <span className="text-[#c0392b] text-xs font-bold tracking-widest uppercase mb-3 block">What We Do</span>
            <h2 className="text-4xl md:text-5xl font-black text-[#1a1a1a] leading-tight">
              Complete Roofing &amp;<br />Exterior Services
            </h2>
          </div>
          <div className="max-w-sm">
            <p className="text-[#666] text-sm leading-relaxed">
              As an Owens Corning Platinum Preferred Contractor with 100+ years of combined experience, we deliver roofing solutions built to last across the Southeast.
            </p>
          </div>
        </div>

        {/* Featured top row — 2 large cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5">
          {services.slice(0, 2).map((svc, i) => (
            <div
              key={i}
              className="group relative overflow-hidden rounded-2xl cursor-pointer h-[380px]"
            >
              <img
                src={svc.img}
                alt={svc.title}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d0d]/90 via-[#0d0d0d]/30 to-transparent"></div>
              <div className="absolute top-5 left-5">
                <span className="bg-[#c0392b] text-white text-[10px] font-bold px-3 py-1.5 rounded-full tracking-widest uppercase">
                  {svc.tag}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-7">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 flex items-center justify-center bg-white/15 backdrop-blur-sm rounded-lg border border-white/20">
                    <i className={`${svc.icon} text-white text-base`}></i>
                  </div>
                  <h3 className="text-white font-black text-xl">{svc.title}</h3>
                </div>
                <p className="text-white/70 text-sm leading-relaxed">{svc.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Middle row — 3 medium cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-5">
          {services.slice(2, 5).map((svc, i) => (
            <div
              key={i}
              className="group relative overflow-hidden rounded-2xl cursor-pointer h-[280px]"
            >
              <img
                src={svc.img}
                alt={svc.title}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d0d]/90 via-[#0d0d0d]/20 to-transparent"></div>
              <div className="absolute top-4 left-4">
                <span className="bg-[#c0392b] text-white text-[10px] font-bold px-3 py-1 rounded-full tracking-widest uppercase">
                  {svc.tag}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2.5 mb-2">
                  <div className="w-8 h-8 flex items-center justify-center bg-white/15 backdrop-blur-sm rounded-lg border border-white/20">
                    <i className={`${svc.icon} text-white text-sm`}></i>
                  </div>
                  <h3 className="text-white font-black text-base">{svc.title}</h3>
                </div>
                <p className="text-white/65 text-xs leading-relaxed">{svc.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom row — 1 wide card */}
        <div className="grid grid-cols-1 gap-5">
          {services.slice(5).map((svc, i) => (
            <div
              key={i}
              className="group relative overflow-hidden rounded-2xl cursor-pointer h-[220px]"
            >
              <img
                src={svc.img}
                alt={svc.title}
                className="absolute inset-0 w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-[#0d0d0d]/90 via-[#0d0d0d]/50 to-transparent"></div>
              <div className="absolute inset-0 flex items-center">
                <div className="p-8 max-w-lg">
                  <span className="bg-[#c0392b] text-white text-[10px] font-bold px-3 py-1 rounded-full tracking-widest uppercase mb-4 inline-block">
                    {svc.tag}
                  </span>
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-9 h-9 flex items-center justify-center bg-white/15 backdrop-blur-sm rounded-lg border border-white/20">
                      <i className={`${svc.icon} text-white text-base`}></i>
                    </div>
                    <h3 className="text-white font-black text-xl">{svc.title}</h3>
                  </div>
                  <p className="text-white/70 text-sm leading-relaxed">{svc.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <a
            href="#contact"
            className="inline-flex items-center gap-2 bg-[#1a1a1a] hover:bg-[#c0392b] text-white font-bold px-10 py-4 rounded-full text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-file-list-3-line"></i>
            Get Your Roofing Estimate
          </a>
        </div>
      </div>
    </section>
  );
}
